import React from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { ItemLine } from "./ItemLine";
import { FormatedPrice } from "./FormatedPrice";
import { SubItem } from "./SubItem";
import { Money } from "@Shared/Components/Money/Money";
import { Rate } from "@Shared/Components/Rate/Rate";
import { Flex } from "@UI/Components/Flex/Flex";
import { Bold } from "@UI/Components/Bold/Bold";

export const ServiceFees = ({
  preview,
  itemFeesCents,
  billingUnit,
  currency,
  billingCount,
  totalExpensesFees,
  serviceFeeRate,
  compact = false,
}) => {
  const MESSAGES = {
    flat: messages.flatRateFee,
    hour: messages.hourlyRateFee,
    day: messages.dailyRateFee,
  };

  const hasNoFees = !itemFeesCents && !totalExpensesFees;

  if (hasNoFees) {
    return null;
  }

  if (compact) {
    const isUnitRate = billingUnit && billingUnit !== "flat";
    return (
      <Flex
        pt={4}
        pb={4}
        justifyContent="space-between"
        borderTopWidth="1px"
        borderTopColor="gray.300"
      >
        <Bold>
          <FormattedMessage {...messages.serviceFee} />
        </Bold>
        <Bold>
          {isUnitRate ? (
            <>
              <Rate
                cents={billingCount > 0 ? Math.round((itemFeesCents || 0) / billingCount) : (itemFeesCents || 0)}
                currency={currency}
                unit={billingUnit}
              />
              {(totalExpensesFees || 0) > 0 && (
                <> + <Money cents={totalExpensesFees} currency={currency} /></>
              )}
            </>
          ) : (
            <Money cents={(itemFeesCents || 0) + (totalExpensesFees || 0)} currency={currency} />
          )}
        </Bold>
      </Flex>
    );
  }

  return (
    <ItemLine title={<FormattedMessage {...messages.serviceFee} />}>
      {itemFeesCents > 0 && (
        <SubItem
          title={
            <FormattedMessage
              {...MESSAGES[billingUnit]}
              values={{
                feeRate: Number(serviceFeeRate),
              }}
            />
          }
          price={
            <FormatedPrice
              preview={preview}
              priceCents={itemFeesCents}
              currency={currency}
              billingUnit={billingUnit}
              billingCount={billingCount}
              rateAmount={itemFeesCents / billingCount / 100}
            />
          }
        />
      )}

      {totalExpensesFees > 0 && (
        <SubItem
          title={
            <FormattedMessage
              {...messages["otherExpensesFee"]}
              values={{
                feeRate: Number(serviceFeeRate),
              }}
            />
          }
          price={<Money cents={totalExpensesFees} currency={currency} />}
        />
      )}

    </ItemLine>
  );
};
